module.exports = __webpack_public_path__ + "static/media/hab8-2.244e47b5.jpg";